module.exports = __webpack_public_path__ + "static/media/Project-vietnam.21805354.svg";